/**
 *
 * @version 12.4.0 #756 MLIBJS-121 Export wd-services as a node module
 * 
 * @author Erik Orozco <eorozco@intersog.com>
 * 
 * @copyright (c) 2020 Build Centrix
 *
 */

var wdAnalytics = require('./wdAnalytics');
var wdDeployment = require('./wdDeployment');
var wdError = require('./wdError');
var wdFilterService = require('./wdFilterService');
var wdFulfillmentGroupService = require('./wdFulfillmentGroupService');
var wdI18n = require('./wdI18n');
var wdJob = require('./wdJob');
var wdOrderService = require('./wdOrderService');
var wdSharedFunctions = require('./wdSharedFunctions');
var wdStatusService = require('./wdStatusService');
var wdStorage = require('./wdStorage');

module.exports = {
    wdAnalyticsService: wdAnalytics.name,
    wdDeploymentService: wdDeployment.name,
    wdErrorService: wdError.name,
    wdFilterService: wdFilterService.name,
    wdFulfillmentGroupService: wdFulfillmentGroupService.name,
    wdI18nService: wdI18n.name,
    wdJobService: wdJob.name,
    wdOrderService: wdOrderService.name,
    wdSharedFunctionsService: wdSharedFunctions.name,
    wdStatusService: wdStatusService.name,
    wdStorageService: wdStorage.name
};

// EOF